/* eslint-disable */
import './forms.css'
import React from 'react'
import { db } from '../services/firebase'
import { Field, reduxForm } from 'redux-form'
import { FormGroup, Row, Col } from 'react-bootstrap'
import Button from 'elements/CustomButton/CustomButton.jsx'
import { renderField, renderSelect } from './_fieldRenderer'
import FileInput from './_fileInput'

class FabricForm extends React.Component {

    state = {
        loading: false,
        fabricLines: []
    }

    componentDidMount() {
        this._fetchFabricLines()
    }


    render() {
        const { loading, fabricLines } = this.state
        const { handleSubmit, submitting, initialValues } = this.props

        return (
            <form onSubmit={handleSubmit}>
                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <Field
                                name='name'
                                type='text'
                                component={renderField}
                                label='Nome'
                                placeholder='Nome'
                            />
                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        <FormGroup>
                            <Field
                                name='fabricLine'
                                component={renderSelect}
                                options={fabricLines}
                                label='Faixa'
                                disabled={loading}
                                placeholder='Selecione'
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    {initialValues && initialValues.downloadURL && (
                        <Col md={12}>
                            <p className='form__help'>
                                Se deseja manter a imagem atual, não utilize o campo abaixo.
                            </p>
                        </Col>
                    )}
                    <Col md={12}>
                        <FormGroup>
                            <Field
                                label='Imagem do tecido'
                                type="file"
                                name="image"
                                component={FileInput}
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col md={6} sm={12} xs={12}>
                        <Button
                            style={{ width: '100%', marginTop: 10 }}
                            bsStyle='danger'
                            type='button'
                            disabled={submitting}
                            onClick={this._handleCancel}
                            wd
                        >
                            Cancelar
                         </Button>
                    </Col>
                    <Col md={6} sm={12} xs={12}>
                        <Button
                            style={{ width: '100%', marginTop: 10 }}
                            bsStyle='default'
                            type='submit'
                            disabled={submitting}
                            fill
                        >
                            Salvar
                         </Button>
                    </Col>
                </Row>
            </form >
        )
    }

    _handleCancel = () => {
        this.props.reset() //form reset - redux-form action creator
        this.props.handleCancel() //function passed via props
    }

    _fetchFabricLines = () => {
        this.setState({ loading: true })
        const fabricLines = []
        db.collection('fabric_lines').get()
            .then(snapshot => {
                if (!snapshot.empty) {
                    snapshot.forEach(s => fabricLines.push({ value: s.id, label: s.data().name }))
                    this.setState({ fabricLines, loading: false })
                }
            })
    }
}

const validate = values => {
    const errors = {}
    if (!values.name) { errors.name = 'Obrigatório' }
    if (!values.image && !values.imageName) { errors.image = 'Obrigatório' }
    if (!values.fabricLine) { errors.fabricLine = 'Obrigatório' }

    return errors
}

FabricForm = reduxForm({ form: 'FabricForm', validate })(FabricForm)
export default FabricForm



// WEBPACK FOOTER //
// ./src/forms/FabricForm.jsx